import React from 'react';

import { Button, Select } from '@gravity-ui/uikit';
import { getI18nLang } from '@yandex-int/i18n';
import clx from 'classnames';
import { getIsYangoRequest } from 'client/utils';
import * as keyset from 'i18n/Common';

import styles from './LangSwitcher.module.scss';

type TLang = keyof typeof keyset;

const createLangSwitchLink = (lang: TLang, returnPath: string, secretKey: string) =>
    `https://www.yandex.ru/portal/set/lang/?intl=${lang}&retpath=${returnPath}&sk=${secretKey}`;

const MAP_LANG_TO_LABEL: Record<TLang, React.ReactElement> = {
    ru: (
        <div className={styles.LangSwitcher__optionalElement}>
            <span className={clx(styles.LangSwitcher__icon, styles.LangSwitcher__icon_ru)} />
            <span className={styles.LangSwitcher__label}>Ru</span>
        </div>
    ),
    en: (
        <div className={styles.LangSwitcher__optionalElement}>
            <span className={clx(styles.LangSwitcher__icon, styles.LangSwitcher__icon_en)} />
            <span className={styles.LangSwitcher__label}>En</span>
        </div>
    ),
} as const;

const isObjectKey = <T extends Record<string, unknown>>(objectKey: PropertyKey, checkObject: T): objectKey is keyof T =>
    objectKey in checkObject;
const availableLangs = Object.keys(keyset).filter((key) => isObjectKey(key, keyset)) as TLang[];

export const LangSwitcher = () => {
    const currLang = getI18nLang();
    const lang = isObjectKey(currLang, MAP_LANG_TO_LABEL) ? currLang : 'en';

    if (getIsYangoRequest()) return null;
    return (
        <Select
            className={styles.LangSwitcher}
            renderControl={({ ref, triggerProps: { onClick, onKeyDown } }) => (
                <Button
                    className={styles.LangSwitcher__optionalElement}
                    ref={ref as React.Ref<HTMLButtonElement>}
                    onClick={onClick}
                    extraProps={{ onKeyDown }}
                    view="flat"
                >
                    {MAP_LANG_TO_LABEL[lang]}
                </Button>
            )}
        >
            {availableLangs
                .filter((availableLang) => availableLang !== lang)
                .map((availableLang) => (
                    <Select.Option key={availableLang} value={availableLang}>
                        <a
                            key={availableLang}
                            className={styles.LangSwitcher__link}
                            href={createLangSwitchLink(availableLang, location.href, __appConfig.secretkey)}
                        >
                            {MAP_LANG_TO_LABEL[availableLang]}
                        </a>
                    </Select.Option>
                ))}
        </Select>
    );
};
